import { render } from "./AdditionalListItem.vue?vue&type=template&id=537bd13f"
import script from "./AdditionalListItem.vue?vue&type=script&lang=js"
export * from "./AdditionalListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__